import { useTranslation } from 'react-i18next';

type Status = 'new' | 'preparing' | 'ready' | 'onway' | 'delivered' | 'cancelled';

interface StatusBadgeProps {
  status: Status;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation();
  
  const statusConfig = {
    new: {
      label: t('new'),
      bgColor: '#EFF6FF',
      textColor: '#3B82F6',
    },
    preparing: {
      label: t('preparing'),
      bgColor: '#FEF3C7',
      textColor: '#F59E0B',
    },
    ready: {
      label: t('ready'),
      bgColor: '#D1FAE5',
      textColor: '#10B981',
    },
    onway: {
      label: t('onTheWay'),
      bgColor: '#EDE9FE',
      textColor: '#8B5CF6',
    },
    delivered: {
      label: 'Delivered',
      bgColor: '#D1FAE5',
      textColor: '#059669',
    },
    cancelled: {
      label: 'Cancelled',
      bgColor: '#FEE2E2',
      textColor: '#EF4444',
    },
  };
  
  const config = statusConfig[status];
  
  return (
    <span
      className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide"
      style={{
        backgroundColor: config.bgColor,
        color: config.textColor,
      }}
    >
      {config.label}
    </span>
  );
}
